import { DropdownPaginated } from 'components/commons';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useApi } from 'hooks';
import { getCustomers } from 'apis/customer.api';

const customerCache = new Map(); // 🔥 shared cache

const SelectCustomer = ({ tabIndex, placeholder = '', accountId, ...props }) => {
  const { request, loading } = useApi({
    api: getCustomers,
    pageError: true
  });

  const [allCustomers, setAllCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = useCallback(
    async (params = {}) => {
      const cacheKey = accountId;

      // ✅ Use cache if available
      if (customerCache.has(cacheKey)) {
        setAllCustomers(customerCache.get(cacheKey));
        setIsLoading(false);
        return;
      }

      const res = await request({
        perPage: 10000,
        productId: accountId === 402 ? 3 : 1,
        ...params
      });

      if (res?.customerAccounts) {
        customerCache.set(cacheKey, res.customerAccounts); // cache it
        setAllCustomers(res.customerAccounts);
      }

      setIsLoading(false);
    },
    [accountId, request]
  );

  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <DropdownPaginated
      {...props}
      request={async ({ search }) => {
        const q = (search || '').toLowerCase();
        const filtered = allCustomers.filter((acc) => {
          const name = `${acc.firstName} ${acc.lastName}`.toLowerCase();
          return name.includes(q);
        });

        return {
          customerAccounts: filtered,
          count: filtered.length
        };
      }}
      total={allCustomers.length}
      loading={loading || isLoading}
      formatRequest={(result) => {
        const { customerAccounts = [] } = result || {};
        return customerAccounts.map((d) => ({
          label: `${d?.customer?.firstName} ${d?.customer?.lastName}`,
          value: d?.customer?.customerId,
          customerId: d?.customer?.customerId,
          customerAccountId: d?.customerAccountId,
          customerAccountNumber: d?.customerAccountNumber,
          lastName: d?.customer?.lastName,
          firstName: d?.customer?.firstName,
          cifNumber: d?.customer?.cifNumber,
          balance: d?.balance
        }));
      }}
      placeholder={placeholder}
      tabIndex={tabIndex}
    />
  );
};

export default SelectCustomer;
